// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ts-button-text.logout p {\n    margin-left: .5rem;\n    margin-right: 0;\n}", "",{"version":3,"sources":["webpack://src/components/Logout/styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".ts-button-text.logout p {\n    margin-left: .5rem;\n    margin-right: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
